<template>
    <div id="edit">
        <div
            v-if="!hasJobNumber"
            uk-alert
            class="uk-alert-danger uk-width-1-2@m uk-margin-top uk-margin-bottom"
        >
            <a
                uk-close
                class="uk-alert-close"
            />
            Note: This payment has no Job ID and cannot be saved.
        </div>
        <edit-payment-form
            :id="id"
            mode="edit"
            :payment="payment"
            :payment-user="user"
            @change="onPaymentChange"
            @reload="getPaymentPayload"
        />
    </div>
</template>

<script>
import { getPaymentPayloadRequest } from '../../helpers/api'
import { mapGetters, mapActions } from 'vuex';
import { cloneObject } from '@strangeanimals/common-vue-components/src/helpers/helpers';
const EditPaymentForm = () => import("../forms/EditPaymentForm");

export default {
    name: 'EditPage',
    components: { EditPaymentForm },
    data: function () {
        return {
            payment: {},
            user: {
                user: {},
                address: {}
            },
            isLoaded: false
        };
    },
    computed: {
        ...mapGetters({
            id: 'activePaymentID'
        }),
        hasJobNumber() {
            return !this.isLoaded || this.payment.jobNumber;
        }
    },
    mounted() {
        this.getPaymentPayload(this.id)
    },
    methods: {
        ...mapActions({
            updateServerTimezone: 'updateServerTimezone'
        }),
        getPaymentPayload(paymentID) {
            const self = this;
            getPaymentPayloadRequest(paymentID).then((response) => {
                if ((response.status === 200) && response.body.hasOwnProperty('id')) {
                    let result = response.body;
                    self.payment = {
                        jobNumber: result.jobNumber,
                        paymentType: result.paymentType,
                        paymentMethod: result.paymentMethod,
                        paymentStatus: result.paymentStatus,
                        paymentState: result.paymentState,
                        amount: result.amount,
                        notes: result.notes,
                        transaction: result.transaction,
                        receiptTypeID: result.receiptTypeID,
                        secondaryUserFirstName: result.secondaryUserFirstName,
                        secondaryUserSurname: result.secondaryUserSurname,
                        secondaryUserEmail: result.secondaryUserEmail,
                        secondaryUserMobileNumber: result.secondaryUserMobileNumber,
                        attachments: result.attachments,
                    };
                    self.user.user = cloneObject(result.paidBy);
                    self.user.address = cloneObject(result.address);
                    self.updateServerTimezone(response.timezone);
                }
                else {
                    self.payment = {};
                    self.user = {};
                }
                self.isLoaded = true;
            });
        },
        onPaymentChange(data) {
            this.payment = data.payment;
        }
    }
}
</script>
